import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SmartEncodingService {

    private gsm7Map: { [key: string]: string } = {
        '“': '"', '”': '"', '„': '"', '«': '"', '»': '"', '‘': "'", '’': "'",
        '‚': "'", '—': '-', '–': '-', '‐': '-', '−': '-', '⁻': '-', '‒': '-',
        '…': '...', '№': 'No', '™': '(TM)', '®': '(R)', '©': '(C)', '¶': 'P',
        '§': 'S', '†': '+', '‡': '++', '•': '-', '⁄': '/', '›': '>', '‹': '<',
        '€': 'EUR', '£': 'GBP', '¥': 'YEN', '¢': 'c', '₤': 'L', '₧': 'Pts',
        '₨': 'Rs', '₩': 'W', '₫': 'd', '₹': 'Rs',
        '±': '+-', '×': 'x', '÷': '/', '∓': '-+', '≈': '~', '≠': '!=', '≤': '<=',
        '≥': '>=', '∞': 'oo',
        '←': '<-', '→': '->', '↑': '^', '↓': 'v', '↔': '<->', '⇄': '<->', '↕': '|',
        'À': 'A', 'Á': 'A', 'Â': 'A', 'Ã': 'A', 'Ä': 'A', 'Å': 'A', 'Æ': 'AE',
        'Ç': 'C', 'È': 'E', 'É': 'E', 'Ê': 'E', 'Ë': 'E', 'Ì': 'I', 'Í': 'I',
        'Î': 'I', 'Ï': 'I', 'Ð': 'D', 'Ñ': 'N', 'Ò': 'O', 'Ó': 'O', 'Ô': 'O',
        'Õ': 'O', 'Ö': 'O', 'Ø': 'O', 'Ù': 'U', 'Ú': 'U', 'Û': 'U', 'Ü': 'U',
        'Ý': 'Y', 'Ÿ': 'Y', 'Þ': 'Th', 'ß': 'ss',
        'à': 'a', 'á': 'a', 'â': 'a', 'ã': 'a', 'ä': 'a', 'å': 'a', 'æ': 'ae',
        'ç': 'c', 'è': 'e', 'é': 'e', 'ê': 'e', 'ë': 'e', 'ì': 'i', 'í': 'i',
        'î': 'i', 'ï': 'i', 'ð': 'd', 'ñ': 'n', 'ò': 'o', 'ó': 'o', 'ô': 'o',
        'õ': 'o', 'ö': 'o', 'ø': 'o', 'ù': 'u', 'ú': 'u', 'û': 'u', 'ü': 'u',
        'ý': 'y', 'ÿ': 'y', 'þ': 'th',
        'Ω': 'Ohm', 'µ': 'u', '°': 'deg', '√': 'sqrt', '∑': 'Sum', '∏': 'Pi',
        '∆': 'Delta', '∫': 'Int', '◊': '*', '★': '*', '☆': '*', '□': '[ ]',
        '\u00A0': ' ',
        '\u200B': '',
        '\u200C': '',
        '\u200D': '',
        '\u2060': '',
    };

    constructor() { }

    encodeText(input: string): string {
        return input.split('').map(char => this.gsm7Map[char] || char).join('');
    }

    containsOtherUnicodeChars(input: string): boolean {
        return [...input].some(char => !(char in this.gsm7Map) && char.charCodeAt(0) > 127);
    }
}
